var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59912 0.0600586C13.0183 0.0600586 16.5991 3.64166 16.5991 8.06006C16.5991 12.4785 13.0183 16.0601 8.59912 16.0601C4.18152 16.0601 0.599121 12.4785 0.599121 8.06006C0.599121 3.64166 4.18152 0.0600586 8.59912 0.0600586ZM11.9991 7.46006H5.19912C5.03999 7.46006 4.88738 7.52327 4.77486 7.63579C4.66234 7.74832 4.59912 7.90093 4.59912 8.06006C4.59912 8.21919 4.66234 8.3718 4.77486 8.48432C4.88738 8.59684 5.03999 8.66006 5.19912 8.66006H11.9991C12.1583 8.66006 12.3109 8.59684 12.4234 8.48432C12.5359 8.3718 12.5991 8.21919 12.5991 8.06006C12.5991 7.90093 12.5359 7.74832 12.4234 7.63579C12.3109 7.52327 12.1583 7.46006 11.9991 7.46006Z",
    fill: "#ACACAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.bdfd1f5b1826318196ae4fdc7ed26aa3.svg";
export { ForwardRef as ReactComponent };